import type { InputHTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { clsx } from 'clsx';

import { SvgSearch } from '@/components/icons';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={clsx(
        'h-9 w-full rounded-lg border border-form-input-border bg-form-input-background px-3 text-sm',
        'text-form-input-text placeholder:text-form-input-text-placeholder',
        'outline-none focus:border-form-input-border-selected focus:bg-table-background',
        'disabled:cursor-not-allowed disabled:text-button-normal-disabled-text',
        className,
      )}
      {...rest}
    />
  );
});

export const SearchInput = forwardRef<HTMLInputElement, InputProps>(
  function SearchInput({ className, ...rest }, ref) {
    return (
      <label className={clsx('relative flex items-center', className)}>
        <span className="pointer-events-none absolute left-2 text-table-text-light">
          <SvgSearch width={14} height={14} />
        </span>
        <Input ref={ref} className="pl-7" {...rest} />
      </label>
    );
  },
);
